type SectionHeadingProps = {
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({ kicker, title, desc, align = 'left' }: SectionHeadingProps) {
  return (
    <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-700">
        {align === 'left' && <span className="h-px w-6 bg-primary-400" />}
        {kicker}
      </p>
      <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}